var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("pain008.list_trans_file") } },
    [
      _c("template", { slot: "pageContent" }, [
        _vm.isSmartphoneOS
          ? _c("div", { attrs: { slot: "fixed" }, slot: "fixed" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    position: "absolute",
                    top: "44px",
                    width: "100%",
                  },
                },
                [
                  _c("cm-messages-filter", {
                    staticClass: "researchfilter",
                    staticStyle: { position: "relative", "z-index": "10" },
                    attrs: {
                      filterType: "list",
                      mode: this.mode,
                      propedServiceId: "9",
                      countResult:
                        _vm.paginationObject.nbResultsTotal.toString(),
                    },
                    on: {
                      refreshInbox: function ($event) {
                        return _vm.refreshInbox()
                      },
                      applyFilter: function ($event) {
                        return _vm.applyFilter($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "listPage", staticStyle: { overflow: "hidden" } },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "12" } },
                  [
                    _c("div", { staticClass: "requestsList" }, [
                      !_vm.isSmartphoneOS
                        ? _c(
                            "div",
                            [
                              _c("cm-messages-filter", {
                                staticClass: "researchfilter",
                                staticStyle: {
                                  position: "relative",
                                  "z-index": "10",
                                },
                                attrs: {
                                  filterType: "list",
                                  mode: this.mode,
                                  randomId: _vm.randomId,
                                  propedServiceId: "9",
                                  countResult:
                                    _vm.paginationObject.nbResultsTotal.toString(),
                                },
                                on: {
                                  applyFilter: function ($event) {
                                    return _vm.applyFilter($event)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isSmartphoneOS
                        ? _c("div", { style: _vm.customMobileLayoutStyle })
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "justify-content-center" },
                      [
                        _c("b-col", { attrs: { sm: "12" } }, [
                          _c("hr", { staticClass: "w-100" }),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      {
                        staticClass: "form-group justify-content-start m-0 p-0",
                      },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "m-0 p-0 mb-2",
                            attrs: { md: "2", cols: "6" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "mr-2 text-left cursor",
                                class: {
                                  "active-tab": _vm.currentTab === "list",
                                  "inactive-tab": _vm.currentTab !== "list",
                                },
                                attrs: { size: "sm" },
                                on: {
                                  click: function ($event) {
                                    return _vm.choseTable("list")
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "fa-duotone fa-file" }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("pain008.list_import_file")) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            staticClass: "m-0 p-0 mb-2",
                            attrs: { md: "2", cols: "6" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "mr-2 text-left cursor",
                                class: {
                                  "active-tab": _vm.currentTab === "data",
                                  "inactive-tab": _vm.currentTab !== "data",
                                },
                                attrs: { size: "sm" },
                                on: {
                                  click: function ($event) {
                                    return _vm.choseTable("data")
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-duotone fa-file-lines",
                                }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("pain008.data_select_file")) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "m-0 p-0 mb-2", attrs: { md: "2" } },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "mr-2 text-center cursor",
                                class: {
                                  "active-tab": _vm.currentTab === "details",
                                  "inactive-tab": _vm.currentTab !== "details",
                                },
                                attrs: { size: "sm" },
                                on: {
                                  click: function ($event) {
                                    return _vm.choseTable("details")
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "fa-duotone fa-grid" }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("pain008.detail_select_file")
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _vm.activateSpinner
                      ? _c("spinner")
                      : _vm.currentTab === "list"
                      ? _c(
                          "div",
                          [
                            _vm.items.length
                              ? _c("b-table", {
                                  ref: "tablePain008Close",
                                  staticClass: "mt-3",
                                  attrs: {
                                    hover: "",
                                    responsive: "",
                                    items: _vm.items,
                                    fields: _vm.fields,
                                    "sort-by": _vm.sortBy,
                                    "sort-desc": _vm.sortDir,
                                    id: "table" + "-" + _vm.randomString,
                                  },
                                  on: {
                                    "update:sortBy": function ($event) {
                                      _vm.sortBy = $event
                                    },
                                    "update:sort-by": function ($event) {
                                      _vm.sortBy = $event
                                    },
                                    "update:sortDesc": function ($event) {
                                      _vm.sortDir = $event
                                    },
                                    "update:sort-desc": function ($event) {
                                      _vm.sortDir = $event
                                    },
                                    "head-clicked": _vm.sortTable,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "cell(fileImport)",
                                        fn: function (row) {
                                          return [
                                            _vm.checkStatus(
                                              row.item.globalState
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "cursor",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showData(
                                                          row.item.IdFile,
                                                          row.index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    row.item.fileImport.length >
                                                    27
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-left",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                    " +
                                                                _vm._s(
                                                                  row.item.fileImport.substr(
                                                                    0,
                                                                    27
                                                                  ) + "..."
                                                                ) +
                                                                "\n                  "
                                                            ),
                                                          ]
                                                        )
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-left",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                row.item
                                                                  .fileImport
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                  ]
                                                )
                                              : _c("div", [
                                                  row.item.fileImport.length >
                                                  27
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-left",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                row.item.fileImport.substr(
                                                                  0,
                                                                  27
                                                                ) + "..."
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-left",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              row.item
                                                                .fileImport
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(dateImport)",
                                        fn: function (row_d) {
                                          return [
                                            _vm.checkStatus(
                                              row_d.item.globalState
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "cursor",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showData(
                                                          row_d.item.IdFile,
                                                          row_d.index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          row_d.item.dateImport
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _c("div", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        row_d.item.dateImport
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(total)",
                                        fn: function (row_tot) {
                                          return [
                                            _vm.checkStatus(
                                              row_tot.item.globalState
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "cursor",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showData(
                                                          row_tot.item.IdFile,
                                                          row_tot.index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          row_tot.item.total
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _c("div", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        row_tot.item.total
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(erro)",
                                        fn: function (row_error) {
                                          return [
                                            _vm.checkStatus(
                                              row_error.item.globalState
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "cursor",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showData(
                                                          row_error.item.IdFile,
                                                          row_error.index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          row_error.item.erro
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _c("div", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        row_error.item.erro
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(validated)",
                                        fn: function (row_validated) {
                                          return [
                                            _vm.checkStatus(
                                              row_validated.item.globalState
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "cursor",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showData(
                                                          row_validated.item
                                                            .IdFile,
                                                          row_validated.index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          row_validated.item
                                                            .validated
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _c("div", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        row_validated.item
                                                          .validated
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(process)",
                                        fn: function (row_process) {
                                          return [
                                            _vm.checkStatus(
                                              row_process.item.globalState
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "cursor",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showData(
                                                          row_process.item
                                                            .IdFile,
                                                          row_process.index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          row_process.item
                                                            .process
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _c("div", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        row_process.item.process
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(verif)",
                                        fn: function (row_verif) {
                                          return [
                                            _vm.checkStatus(
                                              row_verif.item.globalState
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "cursor",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showData(
                                                          row_verif.item.IdFile,
                                                          row_verif.index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          row_verif.item.verif
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _c("div", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        row_verif.item.verif
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(refus)",
                                        fn: function (row_refus) {
                                          return [
                                            _vm.checkStatus(
                                              row_refus.item.globalState
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "cursor",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showData(
                                                          row_refus.item.IdFile,
                                                          row_refus.index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          row_refus.item.refus
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _c("div", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        row_refus.item.refus
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(globalState)",
                                        fn: function (row_state) {
                                          return [
                                            row_state.item.globalState ===
                                            _vm.$t("pain008.file_refused")
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-danger cursor",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          row_state.item
                                                            .globalState
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.checkStatus(
                                              row_state.item.globalState
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "cursor",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showData(
                                                          row_state.item.IdFile,
                                                          row_state.index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          row_state.item
                                                            .globalState
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _c("div", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        row_state.item
                                                          .globalState
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1121518098
                                  ),
                                })
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center",
                                  },
                                  [
                                    _c("span", { staticClass: "noResult" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("common.no_result")) +
                                          "\n              "
                                      ),
                                    ]),
                                  ]
                                ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "justify-content-end mt-5" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "mt-3",
                                    attrs: { lg: "2", offset: "7" },
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.extractCSV_items()
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-solid fa-arrow-up-from-bracket",
                                        }),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t("pain008.extract_list")
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mt-5" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("cm-pagination", {
                                      attrs: {
                                        maxResultsByPage:
                                          _vm.paginationObject.maxResults,
                                        firstIndex:
                                          _vm.paginationObject.firstIndex,
                                        nbResultsTotal:
                                          _vm.paginationObject.nbResultsTotal,
                                        refreshEvent:
                                          _vm.paginationObject.refresh,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm.currentTab === "data"
                      ? _c(
                          "div",
                          [
                            _c(
                              "b-tabs",
                              {
                                attrs: {
                                  "active-nav-item-class":
                                    "active-blue font-weight-bold",
                                },
                                model: {
                                  value: _vm.tabType,
                                  callback: function ($$v) {
                                    _vm.tabType = $$v
                                  },
                                  expression: "tabType",
                                },
                              },
                              [
                                _c(
                                  "b-tab",
                                  {
                                    attrs: {
                                      title: _vm.$t("pain008.legal_person"),
                                      active: _vm.tabType === 0,
                                    },
                                  },
                                  [
                                    this.items[this.currentIndexList]
                                      ? _c(
                                          "b-row",
                                          {
                                            staticClass:
                                              "my-3 justify-content-around",
                                          },
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "mt-3 font-weight-bold",
                                                attrs: { cols: "2" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#6b6aea",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "pain008.imported_file"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", [
                                                  this.items[
                                                    this.currentIndexList
                                                  ].fileImport.length > 27
                                                    ? _c("div", [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              this.items[
                                                                this
                                                                  .currentIndexList
                                                              ].fileImport.substr(
                                                                0,
                                                                27
                                                              ) + "..."
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ])
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-left",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              this.items[
                                                                this
                                                                  .currentIndexList
                                                              ].fileImport
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "mt-3 font-weight-bold",
                                                staticStyle: {
                                                  "margin-left": "-60px",
                                                },
                                                attrs: { cols: "1" },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "pain008.total_2"
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.nbTotalRequest
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "mt-3 font-weight-bold",
                                                attrs: { cols: "1" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#f54336",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "pain008.in_error"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#939393",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      : " +
                                                        _vm._s(
                                                          _vm.nbErrorRequest
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "mt-3 font-weight-bold",
                                                attrs: { cols: "2" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#11b1fd",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "pain008.being_processed"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#939393",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      : " +
                                                        _vm._s(
                                                          _vm.nbBeingProcessedRequest
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "mt-3 font-weight-bold pr-5",
                                                staticStyle: {
                                                  "margin-left": "-50px",
                                                },
                                                attrs: { cols: "1" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "orange",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "pain008.to_verify"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#939393",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      : " +
                                                        _vm._s(
                                                          _vm.nbToVerifyRequest
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "mt-3 font-weight-bold",
                                                attrs: { cols: "1" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#47d89c",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "pain008.validated"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#939393",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      : " +
                                                        _vm._s(
                                                          _vm.nbValidatedRequest
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "mt-3 font-weight-bold",
                                                attrs: { cols: "1" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#f54336",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "pain008.refused"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#939393",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      : " +
                                                        _vm._s(
                                                          _vm.nbRefusedRequest
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticStyle: {
                                                  "margin-left": "-20px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "requestsList",
                                                  },
                                                  [
                                                    !_vm.isSmartphoneOS
                                                      ? _c(
                                                          "div",
                                                          [
                                                            _c(
                                                              "cm-messages-filter-1",
                                                              {
                                                                staticClass:
                                                                  "researchfilter",
                                                                staticStyle: {
                                                                  position:
                                                                    "relative",
                                                                  "z-index":
                                                                    "10",
                                                                },
                                                                attrs: {
                                                                  filterType:
                                                                    "list",
                                                                  mode: this
                                                                    .mode,
                                                                  randomId:
                                                                    _vm.randomId,
                                                                  propedServiceId:
                                                                    "9",
                                                                },
                                                                on: {
                                                                  applyFilter:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.applyFilterData(
                                                                        $event
                                                                      )
                                                                    },
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.isSmartphoneOS
                                                      ? _c("div", {
                                                          style:
                                                            _vm.customMobileLayoutStyle,
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          overflow: "auto",
                                          height: "290px",
                                        },
                                      },
                                      [
                                        _vm.itemsData.length
                                          ? _c("b-table", {
                                              ref: "tablePain008DataClose",
                                              attrs: {
                                                hover: "",
                                                responsive: "",
                                                items: _vm.itemsData,
                                                fields: _vm.fieldsDataPM,
                                                "sort-by": _vm.sortField,
                                                id:
                                                  "table-data" +
                                                  "-" +
                                                  _vm.randomString,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "head(ValidAll)",
                                                    fn: function () {
                                                      return [
                                                        _vm.itemsData.filter(
                                                          function (elem) {
                                                            return (
                                                              elem.StateVerif !==
                                                                _vm.$t(
                                                                  "pain008.positive_response"
                                                                ) &&
                                                              elem.StatusValidation ===
                                                                "1"
                                                            )
                                                          }
                                                        ).length
                                                          ? [
                                                              _c(
                                                                "b-form-checkbox",
                                                                {
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.selectAll(
                                                                          "ValideAll"
                                                                        )
                                                                      },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.allcheckedValid,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.allcheckedValid =
                                                                          $$v
                                                                      },
                                                                    expression:
                                                                      "allcheckedValid",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          color:
                                                                            "var(--actionTextColorBlack)",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                            " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "pain008.validate_all"
                                                                            )
                                                                          ) +
                                                                          "\n                          "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          : [_c("span")],
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                  {
                                                    key: "head(RejectAll)",
                                                    fn: function () {
                                                      return [
                                                        _vm.itemsData.filter(
                                                          function (elem) {
                                                            return (
                                                              elem.StateVerif !==
                                                                _vm.$t(
                                                                  "pain008.positive_response"
                                                                ) &&
                                                              elem.StatusValidation ===
                                                                "1"
                                                            )
                                                          }
                                                        ).length
                                                          ? [
                                                              _c(
                                                                "b-form-checkbox",
                                                                {
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.selectAll(
                                                                          "RejectAll"
                                                                        )
                                                                      },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.allcheckedReject,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.allcheckedReject =
                                                                          $$v
                                                                      },
                                                                    expression:
                                                                      "allcheckedReject",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          color:
                                                                            "var(--actionTextColorBlack)",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                            " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "pain008.decline_all"
                                                                            )
                                                                          ) +
                                                                          "\n                          "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          : [_c("span")],
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                  {
                                                    key: "cell(NameAccount)",
                                                    fn: function (row) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "cursor",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.showDetails(
                                                                  row.index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  row.item
                                                                    .NameAccount
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(Iban)",
                                                    fn: function (row) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "cursor",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.showDetails(
                                                                  row.index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  row.item.Iban
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(Siren)",
                                                    fn: function (row) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "cursor",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.showDetails(
                                                                  row.index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  row.item.Siren
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(VerifIban)",
                                                    fn: function (row) {
                                                      return [
                                                        row.item.VerifIban ==
                                                        "Faux"
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "cursor text-danger",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showDetails(
                                                                        row.index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      row.item
                                                                        .VerifIban
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            )
                                                          : _c("div", {
                                                              staticClass:
                                                                "cursor",
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    row.item
                                                                      .VerifIban
                                                                  ),
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.showDetails(
                                                                      row.index
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(VerifSiren)",
                                                    fn: function (row) {
                                                      return [
                                                        row.item.VerifSiren ==
                                                        "Faux"
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "cursor text-danger",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showDetails(
                                                                        row.index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      row.item
                                                                        .VerifSiren
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            )
                                                          : _c("div", {
                                                              staticClass:
                                                                "cursor",
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    row.item
                                                                      .VerifSiren
                                                                  ),
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.showDetails(
                                                                      row.index
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(StateVerif)",
                                                    fn: function (row) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "cursor",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.showDetails(
                                                                  row.index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  row.item
                                                                    .StateVerif
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(ValidAll)",
                                                    fn: function (row) {
                                                      return [
                                                        row.item.StateVerif !==
                                                        _vm.$t(
                                                          "pain008.positive_response"
                                                        )
                                                          ? [
                                                              row.item
                                                                .StatusValidation ===
                                                              "1"
                                                                ? [
                                                                    _c(
                                                                      "b-form-checkbox",
                                                                      {
                                                                        on: {
                                                                          change:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.decideLine(
                                                                                row,
                                                                                1
                                                                              )
                                                                            },
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            row
                                                                              .item
                                                                              .ValidAll,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                row.item,
                                                                                "ValidAll",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "row.item.ValidAll",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "u",
                                                                          {
                                                                            staticStyle:
                                                                              {
                                                                                color:
                                                                                  "#11b1fd",
                                                                                "font-weight":
                                                                                  "400",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                              " +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "pain008.validate"
                                                                                  )
                                                                                ) +
                                                                                "\n                            "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              row.item
                                                                .StatusValidation ===
                                                              "2"
                                                                ? [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "cursor",
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.showDetails(
                                                                                row.index
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                            " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "pain008.manually_validated"
                                                                              )
                                                                            ) +
                                                                            "\n                          "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                : _vm._e(),
                                                            ]
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(RejectAll)",
                                                    fn: function (row) {
                                                      return [
                                                        row.item.StateVerif !==
                                                        _vm.$t(
                                                          "pain008.positive_response"
                                                        )
                                                          ? [
                                                              row.item
                                                                .StatusValidation ===
                                                              "1"
                                                                ? [
                                                                    _c(
                                                                      "b-form-checkbox",
                                                                      {
                                                                        on: {
                                                                          change:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.decideLine(
                                                                                row,
                                                                                0
                                                                              )
                                                                            },
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            row
                                                                              .item
                                                                              .RejectAll,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                row.item,
                                                                                "RejectAll",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "row.item.RejectAll",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "u",
                                                                          {
                                                                            staticStyle:
                                                                              {
                                                                                color:
                                                                                  "#000000",
                                                                                "font-weight":
                                                                                  "400",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                              " +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "pain008.refus"
                                                                                  )
                                                                                ) +
                                                                                "\n                            "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              row.item
                                                                .StatusValidation ===
                                                              "3"
                                                                ? [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "cursor",
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.showDetails(
                                                                                row.index
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                            " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "pain008.manually_denied"
                                                                              )
                                                                            ) +
                                                                            "\n                          "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                : _vm._e(),
                                                            ]
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                908194682
                                              ),
                                            })
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-center",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "noResult" },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "common.no_result"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c(
                                      "b-progress",
                                      {
                                        staticClass: "mt-3 mb-5",
                                        attrs: {
                                          height: "20px",
                                          min: _vm.min,
                                          max: _vm.max,
                                        },
                                      },
                                      [
                                        _c("b-progress-bar", {
                                          attrs: {
                                            value: _vm.max - _vm.value,
                                            label:
                                              (
                                                100 -
                                                (_vm.value * 100) / _vm.max
                                              ).toFixed(0) + "%",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-tab",
                                  {
                                    attrs: {
                                      title: _vm.$t("pain008.physical_person"),
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-content-center",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "noResult" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t("pain008.no_PP")
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.itemsData.length
                              ? _c(
                                  "b-row",
                                  { staticClass: "justify-content-end mt-3" },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mt-3",
                                        attrs: { lg: "2", cols: "4" },
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "btn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.extractCSV_itemsData()
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa-solid fa-arrow-up-from-bracket",
                                            }),
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t("pain008.extract_list")
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.itemsData.filter(function (elem) {
                                      return (
                                        elem.StateVerif !==
                                          _vm.$t("pain008.positive_response") &&
                                        elem.StatusValidation === "1"
                                      )
                                    }).length
                                      ? [
                                          _c(
                                            "b-col",
                                            {
                                              staticClass: "mt-3",
                                              attrs: { lg: "2", cols: "4" },
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "btn",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.effacer()
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "pain008.clear_label"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            {
                                              staticClass: "mt-3",
                                              attrs: { lg: "2", cols: "4" },
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: { variant: "primary" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.enregistrer()
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t("pain008.sve")
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm.currentTab === "details"
                      ? _c(
                          "div",
                          [
                            _c(
                              "b-row",
                              { staticClass: "mb-3 justify-content-between" },
                              [
                                this.currentIndex > 0
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-2",
                                        attrs: { lg: "2", cols: "4" },
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "btn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.navDetails(-1)
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa-solid fa-chevrons-left",
                                            }),
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t("pain008.previous")
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                this.currentIndex == 0 &&
                                this.itemsData.length > 1
                                  ? _c(
                                      "b-col",
                                      {
                                        attrs: {
                                          lg: "2",
                                          cols: "4",
                                          offset: "10",
                                        },
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "btn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.navDetails(1)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(_vm.$t("pain008.next")) +
                                                "\n                  "
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "fa-solid fa-chevrons-right",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                this.currentIndex < this.itemsData.length - 1
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-2",
                                        attrs: {
                                          lg: "2",
                                          cols: "4",
                                          offset: "8",
                                        },
                                      },
                                      [
                                        this.currentIndex > 0
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass: "btn",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.navDetails(1)
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$t("pain008.next")
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                    _c("i", {
                                                      staticClass:
                                                        "fa-solid fa-chevrons-right",
                                                    }),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "text-center mb-4" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "bandeau0 text-dark",
                                    staticStyle: {
                                      "background-color": "#f1f1f1",
                                    },
                                  },
                                  [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("pain008.global_response")
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                this.itemsData[_vm.currentIndex].StateVerif ===
                                _vm.$t("pain008.positive_response")
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass: "bandeau2",
                                        staticStyle: {
                                          "background-color":
                                            "#47d89c!important",
                                        },
                                      },
                                      [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              this.itemsData[_vm.currentIndex]
                                                .StateVerif
                                            )
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _c("b-col", { staticClass: "bandeau2" }, [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            this.itemsData[_vm.currentIndex]
                                              .StateVerif
                                          )
                                        ),
                                      ]),
                                    ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "title-label-blue",
                                staticStyle: { width: "350px" },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("pain008.check_bank_details")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.itemsData.length
                              ? _c("b-table", {
                                  ref: "tablePain008DetailsClose",
                                  attrs: {
                                    hover: "",
                                    fixed: "",
                                    items: _vm.itemsDetails,
                                    fields: _vm.fieldsDetails,
                                    "sort-by": _vm.sortField,
                                    id:
                                      "table-details" + "-" + _vm.randomString,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "cell(result)",
                                        fn: function (row) {
                                          return [
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  row.item.result
                                                ),
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    700346640
                                  ),
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "form-accordion",
                              {
                                attrs: {
                                  title: _vm.$t("pain008.info_add"),
                                  isOpen: false,
                                  isTitleUpperCase: false,
                                },
                              },
                              [
                                _vm.itemsData.length
                                  ? _c("b-table", {
                                      ref: "tablePain008DetailsClose",
                                      attrs: {
                                        hover: "",
                                        fixed: "",
                                        items: _vm.itemsOtherDetails,
                                        fields: _vm.fieldsOtherDetails,
                                        "sort-by": _vm.sortField,
                                        id:
                                          "table-details" +
                                          "-" +
                                          _vm.randomString,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.itemsData.filter(function (elem) {
                              return (
                                elem.idrequest ===
                                  _vm.request[_vm.currentIndex].idrequest &&
                                elem.StateVerif !==
                                  _vm.$t("pain008.positive_response") &&
                                elem.StatusValidation === "1"
                              )
                            }).length
                              ? [
                                  _c(
                                    "b-row",
                                    { staticClass: "justify-content-end mt-4" },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "mt-3",
                                          attrs: { md: "2", cols: "6" },
                                        },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass: "btn",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.refuser()
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t("pain008.refus")
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "mt-3",
                                          attrs: { md: "2", cols: "6" },
                                        },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: { variant: "primary" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.validate()
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t("pain008.validate")
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }